// extracted by mini-css-extract-plugin
export default {"card":"app_card__qWiGB","explanation":"app_explanation__tUvCB","clickWall":"app_clickWall__kNMoB","skull":"app_skull__HXhIL"};